<template>
    <el-row
        class="territorio-argentina-inserir"
        :gutter="20"
        style="padding-top: 15px"
    >
        <el-col :span="8">
            <h4 v-if="mostrarTitulo" style="font-weight: 700; padding-bottom: 6px">
                {{ $t('mensagens.territorio.territorioAr.upload.title') }}
            </h4>
            <el-card class="w-full">
                <div v-if="layers.length == 0">
                    <p>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.info')
                        }}
                    </p>
                    <div>
                        <p>
                            {{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.enviar'
                                )
                            }}
                        </p>
                        <el-upload
                            class="upload-demo"
                            drag
                            action="alert"
                            :auto-upload="false"
                            :on-change="onLoadFile"
                            :on-remove="onRemoveFile"
                            :file-list="arquivosUploads"
                            multiple
                            ref="upload"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                {{
                                    $t(
                                        'mensagens.territorio.territorioAr.upload.card'
                                    )
                                }}
                            </div>
                        </el-upload>
                    </div>

                    <el-divider>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.ou')
                        }}</el-divider
                    >
                    <div>
                        <p>
                            {{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.manual'
                                )
                            }}
                        </p>
                        <el-button
                            type="primary"
                            icon="el-icon-edit"
                            style="width: 100%"
                            @click="onActiveMap"
                            >{{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.botao'
                                )
                            }}</el-button
                        >
                    </div>
                    <!-- <el-divider>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.ou')
                        }}</el-divider
                    >
                    <p>
                        {{
                            $t('mensagens.territorio.territorioAr.upload.cuit')
                        }}
                    </p> -->
                    <!-- <div>
                        <span>CUIT</span>
                        <el-input
                            placeholder="Ex 093182948"
                            prefix-icon="el-icon-search"
                            v-model="input2"
                        >
                        </el-input>
                    </div> -->
                </div>
                <div v-else style="background: #f5f5f5; border-radius: 4px">
                    <div v-for="(item, index) in layers" :key="index">
                        <div style="padding: 15px">
                            <div>
                                <p>
                                    {{
                                        $t(
                                            'mensagens.territorio.labels.departamento'
                                        )
                                    }}:
                                    <span>{{ item.departamento }}</span>
                                </p>
                                <p>
                                    {{
                                        $t(
                                            'mensagens.territorio.labels.distrito'
                                        )
                                    }}: <span>{{ item.distrito }}</span>
                                </p>
                                <div class="informations">
                                    <dl
                                        style="
                                            width: 18px;
                                            height: 18px;
                                            border-radius: 4px;
                                            background-color: #ddac44;
                                        "
                                    ></dl>
                                    <p>
                                        {{
                                            $t(
                                                'mensagens.territorio.territorioAr.upload.total'
                                            )
                                        }}:
                                    </p>
                                    <span>{{
                                        parseFloat(item.area_ha).toString()
                                    }}</span>
                                </div>
                                <div
                                    class="informations"
                                    v-if="item.totalPlantio"
                                >
                                    <dl
                                        style="
                                            width: 18px;
                                            height: 18px;
                                            border-radius: 4px;
                                            background-color: #346995;
                                        "
                                    ></dl>
                                    <p>
                                        {{
                                            $t(
                                                'mensagens.territorio.territorioAr.upload.plantio'
                                            )
                                        }}:
                                    </p>
                                    <span>{{ item.totalPlantio }}</span>
                                </div>
                            </div>
                        </div>
                        <el-button
                            style="
                                margin: 16px;
                                color: #dc362e;
                                border-color: #dc362e;
                            "
                            :disabled="isRemocaoGeometriaDesabilitada"
                            @click="onRemoveFile(item)"
                        >
                            {{
                                $t(
                                    'mensagens.territorio.territorioAr.upload.eliminar'
                                )
                            }}
                        </el-button>
                    </div>
                </div>
            </el-card>
        </el-col>
        <el-col :span="16">
            <mapa
                class="map-content"
                :mapLayersConfigs="layers"
                :mapConfig="mapConfig"
                :idMapa="'mapaAddTerritorio'"
                :height="'598px'"
                @draw-created="adicionarDesenho"
                @draw-edited="desenhosAlterados"
                @removerTerritorio="removerTerritorio"
                :deslocarPopup="true"
                :menuMaior="true"
                :cadastroTerritorio="true"
                ref="mapa"
            ></mapa>
        </el-col>
    </el-row>
</template>
<script>
import L from 'leaflet';
import Mapa from '@/components/MapaLeaflet';
import geometryUtils from '@/utils/mapa/geometry.js';
import geometryConverter from '@/utils/conversorGeometrias';
import { mapActions } from 'vuex';

export default {
    name: 'informacaoEspecial',
    data() {
        return {
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    popupControl: true,
                    drawControl: true
                },
                dontZoomIn: true,
                fitBounds: true,
                addLimitesEstado: false,
                inspecionar: true
            },
            mapa: '',
            layersMaps: [],
            arquivosUploads: [],
            geometryDesenho: null
        };
    },
    props: {
        isEdit: {
            type: Boolean,
            default: true
        },
        layers: {
            type: Array,
            default: () => []
        },
        geometria: {
            type: Object,
            default: () => {}
        },
        informacoes: {
            type: Object,
            default: () => {}
        },
        codigoLyra: {
            type: String,
            default: ''
        },
        mostrarTitulo: {
            type: Boolean,
            default: true
        }
    },
    components: { Mapa },
    computed: {
        isRemocaoGeometriaDesabilitada() {
            return !!String(this.codigoLyra || '').trim();
        }
    },
    methods: {
        ...mapActions(['replaceTerritoryTableData']),

        onActiveMap() {
            this.$refs.mapa.draw();
        },

        onDelete() {
            this.arquivosUploads = [];
        },

        onLoadFile(file) {
            const reader = new FileReader();
            const extension = file.name.split('.').pop().toLowerCase();
            reader.onload = this.handleLeituraArquivo.bind(
                this,
                file,
                extension
            );
            reader.readAsText(file.raw);
        },

        async handleLeituraArquivo(file, extension, e) {
            try {
                const geometria = await geometryConverter.read(
                    extension,
                    e.target.result,
                    file.raw
                );
                this.processarGeometria(geometria, file.name);
                this.arquivosUploads.push({
                    id: file.uid,
                    layer: geometria,
                    name: file.name
                });
            } catch (rejectReason) {
                this.$refs.upload.clearFiles();
                this.$notify.error({ message: rejectReason });
            }
        },

        async processarGeometria(geometria, fileName) {
            this.filtrarGeometrias(geometria);
            const rootLayers = geometria.getLayers();

            if (!rootLayers || rootLayers.length === 0) {
                this.$refs.upload.clearFiles();
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.arquivoNaoPossuiGeometriaValida'
                    )
                });
                return;
            }

            const features = [];

            rootLayers.forEach(layer => {
                try {
                    const geo = layer.toGeoJSON();
                    if (geo && geo.geometry && geo.geometry.type !== 'Point') {
                        features.push(geo);
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.warn(
                        '[IGNORADO] layer inválido no toGeoJSON:',
                        layer
                    );
                }
            });

            if (features.length === 0) {
                // eslint-disable-next-line no-console
                console.warn(
                    '[AVISO] Nenhum Feature válido com geometria encontrada'
                );
                return;
            }

            let geoCorrigida =
                features.find(
                    f =>
                        f.geometry?.type === 'Polygon' ||
                        f.geometry?.type === 'MultiPolygon'
                )?.geometry || features[0].geometry;

            if (
                geoCorrigida?.type === 'GeometryCollection' &&
                Array.isArray(geoCorrigida.geometries)
            ) {
                const geometriaValida = geoCorrigida.geometries.find(
                    g => g.type === 'Polygon' || g.type === 'MultiPolygon'
                );

                if (!geometriaValida) {
                    // eslint-disable-next-line no-console
                    console.warn(
                        '[ERRO] Nenhum Polygon/MultiPolygon encontrado na GeometryCollection:',
                        geoCorrigida
                    );
                    return;
                }

                geoCorrigida = geometriaValida;
            }

            geoCorrigida = this.verificaTipoCorretoGeometria(geoCorrigida);

            const layerTmp = L.geoJSON(geoCorrigida);
            let camadaCalculada = layerTmp.getLayers()[0];

            if (camadaCalculada && camadaCalculada.simplify) {
                const camadaCalculada = layerTmp
                    .getLayers()[0]
                    ?.simplify(0.001);
                // eslint-disable-next-line no-console
                console.warn(
                    '[SIMPLIFICADA] toGeoJSON():',
                    camadaCalculada.toGeoJSON()
                );
            }

            if (!camadaCalculada || !camadaCalculada.toGeoJSON) {
                // eslint-disable-next-line no-console
                console.warn(
                    '[AVISO] Nenhum layer encontrado no geoJSON para cálculo de área'
                );
                return;
            }

            const area = geometryUtils.calcularAreaHaFromLayer(camadaCalculada);
            const geoFinal = camadaCalculada.toGeoJSON().geometry;

            if (!geoFinal || !geoFinal.type || !geoFinal.coordinates) {
                // eslint-disable-next-line no-console
                console.warn(
                    '[ERRO] Geometria inválida antes do envio para o backend:',
                    geoFinal
                );
                return;
            }

            const territorio = {
                identificadorGeometria: geometria._leaflet_id,
                type: 'UPLOAD',
                codigo: 'UPLOAD',
                area_ha: area,
                geometry: geoFinal,
                fileName,
                departamento: '',
                distrito: ''
            };

            this.$emit('add', territorio);

            try {
                /* eslint-disable no-unused-expressions */
                geometria.setStyle?.({ color: 'red' });
                this.$refs.mapa?.mapa?.addLayer(geometria);
                this.$refs.mapa?.mapa?.fitBounds(geometria.getBounds());
                /* eslint-enable no-unused-expressions */
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn(
                    '[AVISO] Erro ao estilizar ou adicionar no mapa:',
                    e
                );
            }
        },

        onRemoveFile(file) {
            if (this.isRemocaoGeometriaDesabilitada) {
                return;
            }

            const indexRemover = this.arquivosUploads.findIndex(
                o => o.uid === file.id
            );
            if (indexRemover !== -1) {
                this.$refs.mapa.mapa.removeLayer(
                    this.arquivosUploads[indexRemover].layer
                );
                this.arquivosUploads.splice(indexRemover, 1);
            }

            const index = this.layers.findIndex(
                d => d.identificadorGeometria === file.identificadorGeometria
            );
            if (index !== -1) {
                const layer = this.layers[index];
                this.$emit('remover', index);
                this.$refs.mapa.mapa.removeLayer(layer);
            }
        },

        removerTerritorio(identificadorGeometria) {
            if (this.isRemocaoGeometriaDesabilitada) {
                return;
            }

            this.layers.forEach((item, index) => {
                if (identificadorGeometria === item.identificadorGeometria) {
                    this.$emit('remover', index);
                }
            });
        },

        adicionarDesenho(desenho) {
            desenho.identificadorGeometria = desenho._leaflet_id;
            const territorio = {
                identificadorGeometria: desenho._leaflet_id,
                type: 'Desenho de geometria',
                codigo: 'DESENHO',
                area_ha: geometryUtils.calcularAreaHaFromLayer(desenho),
                geometry: desenho.toGeoJSON().geometry,
                geoJson: desenho.toGeoJSON().geometry,
                departamento: '',
                distrito: ''
            };
            this.$emit('add', territorio);
        },

        desenhosAlterados(desenhosAlterados) {
            desenhosAlterados.eachLayer(layer => {
                const areaHa = geometryUtils.calcularAreaHaFromLayer(layer);
                const geometry = layer.toGeoJSON().geometry;

                this.replaceTerritoryTableData({
                    identificadorGeometria: layer._leaflet_id,
                    geometry,
                    areaHa
                });
            });
        },

        filtrarGeometrias(layerGeometrias) {
            if (!layerGeometrias) return;
            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }
                        if (layer instanceof L.Polyline) {
                            const coordinates = layer.getLatLngs();
                            if (!this.isValidLatLngArray(coordinates)) {
                                // eslint-disable-next-line no-console
                                console.warn(
                                    'Coordenadas inválidas para Polyline:',
                                    coordinates
                                );
                                return;
                            }
                            return this.filtrarGeometrias(layer);
                        }
                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },

        isValidLatLngArray(latlngArray) {
            if (!Array.isArray(latlngArray) || latlngArray.length === 0) {
                return false;
            }

            return latlngArray.every(coord => {
                if (Array.isArray(coord)) return this.isValidLatLngArray(coord);
                return (
                    coord &&
                    coord.lat !== undefined &&
                    coord.lng !== undefined &&
                    coord.lat >= -90 &&
                    coord.lat <= 90 &&
                    coord.lng >= -180 &&
                    coord.lng <= 180
                );
            });
        },

        verificaTipoCorretoGeometria(geometria) {
            if (geometria.type === 'LineString') {
                const coordinates = [...geometria.coordinates];
                if (coordinates.length === 0) return null;
                coordinates.push(coordinates[0]);
                return {
                    type: 'Polygon',
                    coordinates: [coordinates]
                };
            }
            return geometria;
        }
    }
};
</script>

<style lang="scss">
.territorio-argentina-inserir {
    .el-card {
        height: calc(598px - 25.6px);
        .el-card__body {
            height: calc(598px - 25.6px);
            overflow-y: scroll;
        }
    }
}
.map-content-infor-especial {
    padding-top: 23px;
    width: 100%;
    height: 598px;
}
.informations {
    display: flex;
    align-items: center;
    gap: 5px;

    dl,
    p {
        margin: 0;
    }
    p {
        font-weight: bold;
    }
}
</style>
